import React, { useEffect, useState } from 'react';
import api from '../services/api';

// Simple seat component
function Seat({ seat, onClick, selected }){
  const cls = `seat ${seat.status === 'sold' || seat.status === 'booked' ? 'seat--unavailable' : ''} ${selected ? 'seat--selected' : ''}`;
  return (
    <button type="button" className={cls} onClick={onClick} disabled={seat.status === 'sold' || seat.status === 'booked'}>
      {seat.label}
      <div className="seat-price">{seat.price ? `₹${seat.price}` : ''}</div>
    </button>
  );
}

export default function ClerkTransactions(){
  return <div className="p-4">Open /clerk/transactions — use Inline view from Dashboard for POS.</div>;
}

// Inline transactions panel used in Dashboard
export function InlineTransactions({ onClose }){
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(()=>{ fetchPayments(); }, []);

  async function fetchPayments(){
    setLoading(true); setError(null);
    try{
      const r = await api.get('/payments', { params: { limit: 100 } });
      setPayments(Array.isArray(r.data) ? r.data : []);
    }catch(e){ setError(e.userMessage || 'Failed to load payments'); setPayments([]); }
    finally{ setLoading(false); }
  }

  return (
    <div className="p-4 bg-white rounded shadow mt-4">
      <div className="flex justify-between items-center mb-3">
        <h4 className="font-semibold">Transactions</h4>
        <div className="flex items-center gap-2">
          <button className="btn btn-outline btn-sm" onClick={fetchPayments}>Refresh</button>
          <button className="btn btn-ghost btn-sm" onClick={onClose}>Close</button>
        </div>
      </div>

      {loading && <div className="text-sm text-gray-600">Loading payments…</div>}
      {error && <div className="text-red-600 text-sm mb-2">{error}</div>}
      {!loading && payments.length===0 && <div className="text-sm text-gray-600">No payments</div>}

      {!loading && payments.length>0 && (
        <div className="overflow-x-auto">
          <table className="table-auto w-full text-sm">
            <thead>
              <tr className="text-left bg-gray-50">
                <th className="p-2">ID</th>
                <th className="p-2">Booking</th>
                <th className="p-2">Method</th>
                <th className="p-2">Status</th>
                <th className="p-2">Transaction ID</th>
                <th className="p-2">Created</th>
                <th className="p-2">Updated</th>
              </tr>
            </thead>
            <tbody>
              {payments.map(p => (
                <tr key={p.id} className="border-t">
                  <td className="p-2">{p.id}</td>
                  <td className="p-2">{p.booking_id}</td>
                  <td className="p-2">{p.method}</td>
                  <td className="p-2">{p.status}</td>
                  <td className="p-2">{p.transaction_id}</td>
                  <td className="p-2">{p.createdAt}</td>
                  <td className="p-2">{p.updatedAt}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
